import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { FormFieldBlueprint } from '@backstage/plugin-scaffolder-react/alpha';
import { OciRegionPickerField } from './OciRegionPicker';
import { OciCompartmentPickerField } from './OciCompartmentPicker';
import { OciVcnPickerField } from './OciVcnPicker';
import { OciSubnetPickerField } from './OciSubnetPicker';
import { OciAvailabilityDomainPickerField } from './OciAvailabilityDomainPicker';
import { OciApproverPickerField } from './OciApproverPicker';
import { OciImagePickerField } from './OciImagePicker';
import { OciShapePickerField } from './OciShapePicker';
import { OciSecurityRulesBuilderField } from './OciSecurityRulesBuilder';
import { OciBlockVolumeManagerField } from './OciBlockVolumeManager';

// `field` is a `() => Promise<FormField>` loader by design (that's the only
// shape FormFieldBlueprint accepts) but these components are imported
// directly above rather than via `import('./OciXxxPicker')`, so the promise
// resolves on the next microtask instead of waiting on a separate JS chunk.
// The lazy-`import()` version of this file caused an intermittent bug: if
// the wizard's first render raced ahead of the chunk finishing (which
// depended on how the user navigated to /create/templates/... — direct link
// vs. through the Templates list — and on network/cache conditions), RJSF
// silently fell back to default text/select widgets for every OCI field
// instead of erroring, since an unresolved `ui:field` name just renders the
// schema's default widget. Bundling these fields with the rest of the
// scaffolder module removes the race entirely.

const OciRegionPickerExtension = FormFieldBlueprint.make({
  name: 'OciRegionPicker',
  params: {
    field: async () => OciRegionPickerField,
  },
});

const OciCompartmentPickerExtension = FormFieldBlueprint.make({
  name: 'OciCompartmentPicker',
  params: {
    field: async () => OciCompartmentPickerField,
  },
});

const OciVcnPickerExtension = FormFieldBlueprint.make({
  name: 'OciVcnPicker',
  params: {
    field: async () => OciVcnPickerField,
  },
});

const OciSubnetPickerExtension = FormFieldBlueprint.make({
  name: 'OciSubnetPicker',
  params: {
    field: async () => OciSubnetPickerField,
  },
});

const OciAvailabilityDomainPickerExtension = FormFieldBlueprint.make({
  name: 'OciAvailabilityDomainPicker',
  params: {
    field: async () => OciAvailabilityDomainPickerField,
  },
});

const OciApproverPickerExtension = FormFieldBlueprint.make({
  name: 'OciApproverPicker',
  params: {
    field: async () => OciApproverPickerField,
  },
});

const OciImagePickerExtension = FormFieldBlueprint.make({
  name: 'OciImagePicker',
  params: {
    field: async () => OciImagePickerField,
  },
});

const OciShapePickerExtension = FormFieldBlueprint.make({
  name: 'OciShapePicker',
  params: {
    field: async () => OciShapePickerField,
  },
});

const OciSecurityRulesBuilderExtension = FormFieldBlueprint.make({
  name: 'OciSecurityRulesBuilder',
  params: {
    field: async () => OciSecurityRulesBuilderField,
  },
});

const OciBlockVolumeManagerExtension = FormFieldBlueprint.make({
  name: 'OciBlockVolumeManager',
  params: {
    field: async () => OciBlockVolumeManagerField,
  },
});

export const ociPickersModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    OciRegionPickerExtension,
    OciCompartmentPickerExtension,
    OciVcnPickerExtension,
    OciSubnetPickerExtension,
    OciAvailabilityDomainPickerExtension,
    OciApproverPickerExtension,
    OciImagePickerExtension,
    OciShapePickerExtension,
    OciSecurityRulesBuilderExtension,
    OciBlockVolumeManagerExtension,
  ],
});
